import * as _ from 'lodash';
import { newThemesCmsMapping } from '@wix/adi-core-types';
export function replaceWithNewKitIds(kitsIds) {
    var newKitIds = !kitsIds
        ? []
        : kitsIds.map(function (kitIdToReplace) {
            var newKitId = newThemesCmsMapping[kitIdToReplace];
            return newKitId === undefined ? kitIdToReplace : newKitId;
        });
    return _.uniq(newKitIds);
}
//# sourceMappingURL=replaceWithNewKitIds.js.map